/**
 * 注册弹窗顶部提示信息条
 * - 按类型（success/error/info）渲染背景色、图标与文案颜色
 */
import { Check, AlertCircle } from 'lucide-react';
import type { ToastType } from '../types';

export function ModalToast({ message, type }: { message: string; type: ToastType }) {
  return (
    <div className={`p-4 ${type === 'success' ? 'bg-green-50 border-b border-green-200' : type === 'error' ? 'bg-red-50 border-b border-red-200' : 'bg-blue-50 border-b border-blue-200'}`}>
      <div className="flex items-center gap-2">
        {type === 'success' && <Check className="w-5 h-5 text-green-500 flex-shrink-0" />}
        {type === 'error' && <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />}
        <p className={`text-sm ${type === 'success' ? 'text-green-700' : type === 'error' ? 'text-red-700' : 'text-blue-700'}`}>
          {message}
        </p>
      </div>
    </div>
  );
}